// ============================================================
// Primitive 7 — Modal.
// ------------------------------------------------------------
// Écrite sur `<dialog>` natif plutôt que sur une bibliothèque : le
// navigateur fournit déjà le piège de focus, la fermeture par Échap,
// le fond inerte et la sémantique `aria-modal`. Une dépendance de
// moins à maintenir jusqu'à la remise, et un comportement qui ne
// dépend pas d'une version.
// ============================================================

import { useEffect, useId, useRef } from 'react';
import Button from './Button.jsx';

export function Modal({ open, onClose, title, children, footer, large = false }) {
  const ref = useRef(null);
  const titleId = useId();

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    // Échap déclenche `cancel` : on remonte la fermeture au parent pour
    // que l'état React reste la source de vérité.
    const onCancel = (e) => {
      e.preventDefault();
      onClose?.();
    };
    dialog.addEventListener('cancel', onCancel);
    return () => dialog.removeEventListener('cancel', onCancel);
  }, [onClose]);

  return (
    // `large` : presque tout l'écran, pour un travail sur une image
    // (l'éditeur de découpe d'un plan, 14 octobre 2026).
    <dialog ref={ref} className={large ? 'modal modal--large' : 'modal'} aria-labelledby={titleId}>
      <header className="modal__head">
        <h2 className="card__title" id={titleId}>
          {title}
        </h2>
        <Button variant="ghost" icon aria-label="Fermer" onClick={onClose}>
          ×
        </Button>
      </header>
      <div className="modal__body">{children}</div>
      {footer ? <footer className="modal__foot">{footer}</footer> : null}
    </dialog>
  );
}

export default Modal;
